/* eslint-disable no-case-declarations,no-param-reassign */
/* global G */
import { bulk, curry, setKey } from 'lib/util'
import asObject from 'lib/sequence/component/children/asObject'
import validate from 'lib/sequence/model/validate'
import findDevice from 'app/_shared/events/device/find'
import { get } from 'lib/sequence/component/state/value'
import { hide } from 'lib/sequence/component/state/hidden'
import { actionWithHooks } from 'lib/sequence/module/action'
import setStepTab, { RESULT } from 'app/_shared/events/setStepTab'
import modelReset from 'lib/sequence/model/api/reset'
import find from 'lib/sequence/component/children/find'
import setItem from 'app/request/event/setItem'

const bulkHide = bulk(hide)
const bulkModelReset = bulk(modelReset)

/**
 * Validates the serial field and uses {@link findDevice} to attempt to find a product  while
 * handling the different possibilities:
 *  * If a device is found it means that the product we need is attached to it, so we show a warning
 *  * If no product is found, we show an info message
 *  * If an available product is found, we go to the next step
 *
 * @param {Gaia.AppModule.Spec} module  the current module composition object
 * @param {Gaia.Component.Spec} component  the current action's main component
 * @param {Event} event                 the event object that triggered this handler
 * @returns {Promise<void>} void
 */
const searchProduct = curry(async (module, component, event) => {
  const model = module[G.MODEL]
  const { itemData, item, product, equipment, itemInstalledAt } = model[G.CHILDREN]
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { stepper } = asObject(actionComponent[G.CHILDREN])
  const { device } = asObject(stepper[G.CHILDREN])
  const { search } = asObject(device[G.CHILDREN])
  const { actions } = asObject(search[G.CHILDREN])
  const { form } = asObject(actions[G.CHILDREN])
  const { serial: serialField, options } = asObject(form[G.CHILDREN])
  const { existingHelp, btnMore } = asObject(options[G.CHILDREN])
  const { resultsList } = find(actionComponent)

  // clear all item-dependant fields
  bulkModelReset(
    item,
    equipment,
    product,
    itemInstalledAt,
  )
  // hiding help buttons
  bulkHide(existingHelp, btnMore)

  setKey(null, G.ERROR, item[G.STATE])
  // validate serial field
  await validate(itemData)(form)

  // if serial field is valid
  if (!itemData[G.STATE][G.ERROR]) {
    // get its value
    const serial = get(serialField)
    // use its value to look for an item, equipment or product
    const devices = await findDevice(module, serialField, serial)

    devices?.length > 1
      ? setKey({ term: serial }, G.META, resultsList[G.STATE])
        && await setStepTab(RESULT)(module, component, event)
      : await setItem(module, component, devices?.[0])
  }
  await actionWithHooks(module[G.STATE][G.ACTION])([])
})

export default searchProduct
